export const complaints = {
    namespaced: true,
    state: {
        status: 'init'
    },
    mutations: {
        SET_STATUS(state, status) {
            state.status = status
        }
    },
    actions: {
        sendComplaint({ state, commit }, payload) {
            commit('SET_STATUS', 'pending')
            return this.$api.post('client/v2/complaints/add', payload, {
                'Content-Type': 'multipart/form-data'
            }).then(response => {
                commit('SET_STATUS', 'idle')
                if(response.status === 200) {
                    return response.data.data.confirmation
                }
                return Promise.reject(new Error('Wystąpił nieokreślony błąd'))
            }).catch(error => {
                commit('SET_STATUS', 'idle')
                return Promise.reject(error.response && error.response.data && error.response.data.message ? error.response.data.message : error)
            })
        }
    },
    getters: {
        status: state => state.status
    }
}
